/*
 * Emballage cadeau + carte (système Et Hop).
 * Case « C'est pour offrir ? » dans le panier (page /cart et tiroir), fenêtre en deux étapes (1. la carte,
 * 2. le message facultatif : beaucoup de clients ne descendaient pas jusqu'au message), ajout au panier de la variante choisie avec ses propriétés. Données : window.HopEmballage
 * (snippets/emballage-cadeau.liquid).
 */
(function () {
  'use strict';
  var C = window.HopEmballage;
  if (!C || !C.cartes || !C.cartes.length) return;
  var MAX_MESSAGE = 300, MAX_NOM = 60;
  var etat = { ligne: null };   // ligne « emballage » du panier (ou null)
  var PRODUITS = C.cartes.map(function (c) { return c.produit; });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Pendant une commande groupée, pas d'emballage cadeau.
  function enCommandeGroupee() { try { return !!JSON.parse(localStorage.getItem('hopCommandeGroupee') || 'null'); } catch (e) { return false; } }

  function lirePanier() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        etat.ligne = (panier.items || []).filter(function (i) { return PRODUITS.indexOf(i.handle) !== -1 || (i.properties && i.properties._emballage); })[0] || null;
        return panier;
      });
  }

  // --- Case dans le panier ---------------------------------------------------
  function caseHtml() {
    var l = etat.ligne;
    var detail = l ? '<span class="hop-ec-case__detail">' + esc(l.variant_title || '') +
      (l.properties && l.properties.Destinataire ? ' · pour ' + esc(l.properties.Destinataire) : '') +
      ' · <button type="button" class="hop-ec-case__modifier" data-hop-ec-modifier>Modifier</button></span>' : '';
    return '<input type="checkbox" data-hop-ec-case' + (l ? ' checked' : '') + '>' +
      '<span>C’est pour offrir ? Ajoutez une carte et un emballage cadeau' + detail + '</span>';
  }

  function placer() {
    var conteneurs = document.querySelectorAll('.cart__ctas');
    Array.prototype.forEach.call(conteneurs, function (ctas) {
      var parent = ctas.parentNode;
      var existante = parent.querySelector(':scope > .hop-ec-case');
      if (enCommandeGroupee()) { if (existante) existante.remove(); return; }
      if (!existante) {
        existante = document.createElement('label');
        existante.className = 'hop-ec-case';
        // tout en haut du récapitulatif, au-dessus du widget de fidélité et du total
        parent.insertBefore(existante, parent.firstChild);
      }
      var html = caseHtml();
      if (existante.getAttribute('data-html') !== html) { existante.innerHTML = html; existante.setAttribute('data-html', html); }
    });
  }

  document.addEventListener('click', function (e) {
    var modifier = e.target.closest && e.target.closest('[data-hop-ec-modifier]');
    if (modifier) { e.preventDefault(); ouvrir(); return; }
  });
  // « Modifier les options » de l'app d'options (YMQ) sur la ligne de la carte : ouvre notre fenêtre à la place
  // (écouté sur window, en capture, pour passer avant le gestionnaire de l'app).
  var IDS_CARTES = C.cartes.map(function (c) { return String(c.id); });
  window.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('[ymq-option-action="cart-edit"]');
    var info = bouton && bouton.closest('[ymq-option-cart-info]');
    if (!info) return;
    var variante; try { variante = String(JSON.parse(info.getAttribute('ymq-option-cart-info')).variant_id); } catch (err) { return; }
    if (IDS_CARTES.indexOf(variante) === -1) return;
    e.preventDefault(); e.stopImmediatePropagation();
    lirePanier().then(ouvrir, ouvrir);
  }, true);
  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('[data-hop-ec-case]');
    if (!c) return;
    if (c.checked) { c.checked = !!etat.ligne; ouvrir(); }
    else if (etat.ligne) {
      if (!confirm('Retirer l’emballage cadeau et la carte ?')) { c.checked = true; return; }
      changerPanier({ id: etat.ligne.key, quantity: 0 }, '/cart/change.js');
    }
  });

  // --- Fenêtre de choix ------------------------------------------------------
  var fond = null;
  function fermer() { if (fond) { fond.remove(); fond = null; document.removeEventListener('keydown', echap); } }
  function echap(e) { if (e.key === 'Escape') fermer(); }

  function ouvrir() {
    fermer();
    var l = etat.ligne, p = (l && l.properties) || {};
    var choisie = l ? l.variant_id : null;
    fond = document.createElement('div');
    fond.className = 'hop-ec-fond';
    fond.innerHTML =
      '<div class="hop-ec-fenetre" role="dialog" aria-modal="true" aria-labelledby="hop-ec-titre">' +
        '<div class="hop-ec-tete"><h2 id="hop-ec-titre"></h2><button type="button" class="hop-ec-fermer" aria-label="Fermer" data-hop-ec-fermer>×</button></div>' +
        '<form class="hop-ec-corps" data-hop-ec-form novalidate>' +
          '<div class="hop-ec-etape1">' +
          '<p class="hop-ec-note">🎁 Votre commande sera livrée directement dans un <strong>emballage cadeau</strong>, <strong>sans bon de commande ni facture</strong>. Votre message personnel sera <strong>imprimé au verso de la carte choisie</strong>.</p>' +
          '<div class="hop-ec-cartes">' +
          C.cartes.map(function (c, i) {
            return '<label class="hop-ec-carte"><input type="radio" name="carte" value="' + c.id + '"' +
              ((choisie ? choisie === c.id : i === 0) ? ' checked' : '') + '>' +
              '<span class="hop-ec-carte__image">' + (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="hop-ec-carte__titre">' + esc(c.titre) + '</span>' +
              '<span class="hop-ec-carte__prix">' + (c.prix_barre ? '<s>' + esc(c.prix_barre) + '</s> ' : '') + esc(c.prix) + '</span></label>';
          }).join('') +
          '</div>' +
          '</div>' +
          '<div class="hop-ec-etape2">' +
          '<div class="hop-ec-choix"><span data-hop-ec-choix></span><button type="button" class="hop-ec-lien" data-hop-ec-retour>← Changer de carte</button></div>' +
          '<div class="hop-ec-champs">' +
            '<label>De la part de <span class="hop-ec-facultatif">(facultatif)</span><input name="de" maxlength="' + MAX_NOM + '" placeholder="De la part de" value="' + esc(p['De la part de'] || '') + '"></label>' +
            '<label>Destinataire <span class="hop-ec-facultatif">(facultatif)</span><input name="pour" maxlength="' + MAX_NOM + '" placeholder="Destinataire" value="' + esc(p.Destinataire || '') + '"></label>' +
            '<label class="hop-ec-large">Message <span class="hop-ec-facultatif">(facultatif)</span><textarea name="message" maxlength="' + MAX_MESSAGE + '" placeholder="Message">' + esc(p.Message || '') + '</textarea>' +
              '<span class="hop-ec-compte" data-hop-ec-compte></span></label>' +
          '</div>' +
          '</div>' +
        '</form>' +
        '<div class="hop-ec-pied"><span class="hop-ec-erreur" data-hop-ec-erreur role="alert"></span>' +
          '<button type="button" class="hop-ec-confirmer hop-ec-suivant" data-hop-ec-suivant>Suivant</button>' +
          '<button type="button" class="hop-ec-confirmer" data-hop-ec-confirmer></button></div>' +
      '</div>';
    document.body.appendChild(fond);
    document.addEventListener('keydown', echap);
    var form = fond.querySelector('[data-hop-ec-form]');
    var compte = fond.querySelector('[data-hop-ec-compte]');
    var bouton = fond.querySelector('[data-hop-ec-confirmer]');
    var maj = function () {
      compte.textContent = form.message.value.length + ' / ' + MAX_MESSAGE;
      var vide = !(form.de.value.trim() || form.pour.value.trim() || form.message.value.trim());
      bouton.textContent = vide ? 'Ajouter sans message' : 'Ajouter avec ce message';
    };
    form.addEventListener('input', maj); maj();
    fond.addEventListener('click', function (e) {
      if (e.target === fond || e.target.closest('[data-hop-ec-fermer]')) fermer();
      else if (e.target.closest('[data-hop-ec-retour]')) etape(1);
      else if (e.target.closest('[data-hop-ec-suivant]')) etape(2);
    });
    // Un clic ou un toucher sur une carte passe au message. Au clavier (flèches, Espace : clic avec detail 0),
    // on change de carte sans avancer ; « Suivant » mène au message.
    form.querySelector('.hop-ec-cartes').addEventListener('click', function (e) {
      if (e.detail > 0 && e.target.matches && e.target.matches('input[name=carte]')) setTimeout(function () { etape(2); }, 120);
    });
    bouton.addEventListener('click', function () { confirmer(form, this); });
    etape(l ? 2 : 1);
  }

  function etape(n) {
    var fenetre = fond.querySelector('.hop-ec-fenetre'), form = fond.querySelector('[data-hop-ec-form]');
    var radio = form.querySelector('input[name=carte]:checked');
    if (n === 2 && !radio) { fond.querySelector('[data-hop-ec-erreur]').textContent = 'Choisissez une carte.'; return; }
    fond.querySelector('[data-hop-ec-erreur]').textContent = '';
    fenetre.classList.toggle('hop-ec-fenetre--message', n === 2);
    fond.querySelector('#hop-ec-titre').textContent = n === 2 ? 'Votre message' : 'Choisissez votre carte';
    if (n === 2) {
      var c = C.cartes.filter(function (x) { return String(x.id) === radio.value; })[0];
      fond.querySelector('[data-hop-ec-choix]').innerHTML = (c.image ? '<img src="' + esc(c.image) + '" alt="">' : '') +
        '<span><strong>' + esc(c.titre) + '</strong> · ' + esc(c.prix) + '</span>';
    }
    form.scrollTop = 0;
    setTimeout(function () { (n === 2 ? form.de : radio || form.querySelector('input[name=carte]')).focus(); }, 30);
  }

  function confirmer(form, bouton) {
    var erreur = fond.querySelector('[data-hop-ec-erreur]');
    var carte = form.querySelector('input[name=carte]:checked');
    if (!carte) { erreur.textContent = 'Choisissez une carte.'; return; }
    var props = { _emballage: '1' };
    var de = form.de.value.trim(), pour = form.pour.value.trim(), message = form.message.value.trim();
    if (de) props['De la part de'] = de;
    if (pour) props.Destinataire = pour;
    if (message) props.Message = message;
    // Rien d'écrit : trace visible dans la commande, le panier et l'e-mail que c'est un choix du client
    // (hors du champ Message, pour ne pas ressembler à un message ; ignoré par l'export Messages cartes).
    if (!de && !pour && !message) props['Choix du client'] = 'carte sans message';
    bouton.disabled = true; bouton.textContent = 'Ajout…'; erreur.textContent = '';
    // Modification : l'ancienne carte est remplacée par la nouvelle.
    var avant = etat.ligne ? fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: etat.ligne.key, quantity: 0 })
    }) : Promise.resolve();
    avant.then(function () {
      return changerPanier({ items: [{ id: Number(carte.value), quantity: 1, properties: props }] }, '/cart/add.js');
    }).then(fermer, function () {
      bouton.disabled = false; bouton.textContent = message || de || pour ? 'Ajouter avec ce message' : 'Ajouter sans message';
      erreur.textContent = 'La carte n’a pas pu être ajoutée. Réessayez.';
    });
  }

  // --- Mise à jour du panier puis du thème (tiroir Dawn/Studio, sinon rechargement) ---
  function changerPanier(corps, url) {
    var tiroir = document.querySelector('cart-drawer');
    var avecTiroir = tiroir && typeof tiroir.renderContents === 'function' && location.pathname.indexOf('/cart') !== 0;
    if (avecTiroir) {
      corps.sections = tiroir.getSectionsToRender().map(function (s) { return s.id; });
      corps.sections_url = location.pathname;
    }
    return fetch(url, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (r) {
      if (!r.ok) throw new Error('panier');
      return r.json();
    }).then(function (rep) {
      if (avecTiroir && rep.sections) {
        tiroir.classList.contains('is-empty') && tiroir.classList.remove('is-empty');
        tiroir.renderContents(rep);
        return lirePanier().then(placer);
      }
      location.reload();
    });
  }

  // --- Démarrage : le panier du thème se re-dessine en AJAX ---------------------
  function rafraichir() { lirePanier().then(placer).catch(function () {}); }
  var attente = null;
  var ZONE_PANIER = 'cart-drawer, cart-drawer-items, cart-items, .cart__footer, #main-cart-footer, #CartDrawer';
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (!t.closest || t.closest('.hop-ec-case') || t.closest('.hop-ec-fond')) continue;
      if (!t.closest(ZONE_PANIER) && !(t.querySelector && t.querySelector('.cart__ctas'))) continue;
      clearTimeout(attente); attente = setTimeout(rafraichir, 250); return;
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rafraichir); else rafraichir();
})();
